<div class="field text-left mt-3">
    <div class="flex justify-content-between">
        <div>

            <p-button label="Save" icon="pi pi-save" size="small" (click)="saveSpecification()" [disabled]="Edit"></p-button>

        </div>
    </div>
</div>

<div class="card">
    <div class="grid">
        <div class="col">
            <div class="field-radiobutton flex-wrap">
                <p-radioButton name="Specification" value="default" [(ngModel)]="selectedSpecification" inputId="Specification1"></p-radioButton>
                <label for="Specification1">Specification 1 - Product Master</label>
                <textarea id="comments" placeholder="No Specification Found" pInputTextarea  [(ngModel)]="productSpecification" class="w-full mt-2" readonly></textarea>
            </div>

            <div class="field-radiobutton flex-wrap">
                <p-radioButton name="Specification" value="other" [(ngModel)]="selectedSpecification" inputId="Specification2"></p-radioButton>
                <label for="Specification2">Free-hand Specification</label>
                <textarea id="comments" pInputTextarea  [(ngModel)]="freeHandProductSpecification" class="w-full mt-2"></textarea>
            </div>    
        </div>
    </div>
</div>